var Component = require('./Component');
var Scrollbar = require('./Scrollbar');
var template = require('../template/float-window.html');
var utils = require('./../global/utils');
const { isEmpty } = require('./../global/utils');
var isAnonymousSession = utils.isAnonymousSession;
var FloadWindow = function (options) {
  (function (self) {
    var defaults = {
      template: template,
      tag: '<span class="im-float-tag {$float-tag-selected}" data-id-source="{$id@source}">{$username}</span>',
      perPage: 20,
      pageIndex: 0,
      selectedIndex: 0,
      locked: false,
      width: 80
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  (function (self) {
    var scrollbar = new Scrollbar({
      window: self._element,
      content: self._element.find(".im-float-content")
    });

    self._element.append(scrollbar.getElement());
    self._children['flat-window-scrollbar'] = scrollbar;

    setTimeout(function () {
      scrollbar.init();
    }, 0);

    scrollbar.addEventListener("scrolled", function (scrolltop) {
      if (self.scrollLocked || self.fullfilled) return;
      var wrapHeight = self.getElement().height();
      var listHeight = self.getElement().find(".im-float-content").height();
      if (listHeight < wrapHeight) {
        return false
      }
      if (listHeight - wrapHeight - scrolltop <= 5) {
        if (self._data.maxCount - self._options.perPage * (self._options.pageIndex + 1) > 0) {
          self._options.pageIndex++;
          self.render(self._options.pageIndex * self._options.perPage, (self._options.pageIndex + 1) * self._options.perPage);
          self.scrollToTarget(self._options.selectedIndex);
        } else if (self._element.find('.im-float-content').children().length < self._data.maxCount) {
          self._options.pageIndex++;
          self.render(self._options.pageIndex * self._options.perPage, self._data.maxCount);
          self.scrollToTarget(self._options.selectedIndex);
        }
      }
    });

    self._element.click(function (e) {
      var _target = $(e.target);
      if (e.target.tagName == 'SPAN' && _target.hasClass('im-float-tag')) {
        var id_source = _target.data('id-source');
        var data = self._data.contacts;
        var currentContact = data[id_source];
        if (currentContact) {
          var atName = (currentContact.remark_name || (currentContact.remark && currentContact.remark.remark_name) || currentContact.nick_name || currentContact.user_name) || '未知';
          if((isEmpty(atName) || atName === '未知') && isAnonymousSession(currentContact)){
            atName = '游客'+ currentContact.user_id
          }
          self.outputMessage({
            id: currentContact.user_id,
            source: currentContact.user_source,
            user_name: atName,
            filter: self._data.filter
          });
        }
      }
    });
  })(this);
};
FloadWindow.prototype = Object.create(Component.prototype);
FloadWindow.prototype.open = function () {
  Component.prototype.show.call(this);
  this._options.opened = true;
};
FloadWindow.prototype.close = function () {
  // Component.prototype.hide.call(this);
  //this.hide();
  this._options.opened = false;
};
FloadWindow.prototype.render = function (start, end) {
  var $element = this.getElement(),
    data = this._data.contacts, list = this._data.id_sources,
    innerHtml = '', _index = start || 0, _end = end || (_index + this._options.perPage);
  if (_index == 0) this._options.pageIndex = 0;
  for (; _index < list.length && _index < _end; _index++) {
    if (!data[list[_index]]) continue;
    //判断是否为匿名登陆用户
    var curData = data[list[_index]];
    var atName = (curData.remark_name || (curData.remark && curData.remark.remark_name) || curData.nick_name || curData.user_name) || '未知';
    if((isEmpty(atName) || atName === '未知') && isAnonymousSession(curData)){
      atName = '游客'+ curData.user_id
    }
    innerHtml += this._options.tag.replace('{$username}', atName.replace(/&/gi, '&amp;')).replace('{$id@source}', list[_index]).replace('{$float-tag-selected}', (_index == 0 ? 'float-tag-selected' : ''));
  }
  if (innerHtml.length) {
    if (this._options.pageIndex > 0) {
      $element.find('.im-float-content').append(innerHtml);
    } else {
      $element.find('.im-float-content').html(innerHtml);
    }
    this._children['flat-window-scrollbar'].scrollToTop();
    this.open();
  } else {
    this.close();
  }
};
FloadWindow.prototype.keyboardInput = function (e) {
  var _this = this;
  if (e.keyCode == 13) {
    var data = this._data.contacts, list = this._data.id_sources;
    if (list[this._options.selectedIndex] && data[list[this._options.selectedIndex]]) {
      this.outputMessage({
        id: data[list[this._options.selectedIndex]].user_id,
        source: data[list[this._options.selectedIndex]].user_source,
        user_name: data[list[this._options.selectedIndex]].remark_name || data[list[this._options.selectedIndex]].nick_name || data[list[this._options.selectedIndex]].user_name,
        filter: _this._data.filter
      });
    }
  } else if (e.keyCode == 38 || e.keyCode == 40) {
    this.scrollLocked = true;
    var list = this.getElement().find('.im-float-content').children();
    var index = this._options.selectedIndex;
    index += (e.keyCode == 38) ? -1 : 1;
    if (index > this._data.maxCount - 1) {
      $(list).removeClass('float-tag-selected');
      this._options.selectedIndex = 0;
      $(list[0]).addClass('float-tag-selected');
      setTimeout(function () {
        _this._children['flat-window-scrollbar'].scrollToTop();
        _this.scrollLocked = false;
      }, 0);
    } else if (index < 0) {
      this.scrollLocked = true;
      if (this._options.selectedIndex == 0 && list.length < this._data.maxCount) {
        this.render(0, this._data.maxCount);
        this.fullfilled = true;
        this._options.pageIndex = parseInt(this._data.maxCount / this._options.perPage) + (this._data.maxCount % this._options.perPage > 0 ? 1 : 0);
        list = this.getElement().find('.im-float-content').children();
      }
      $(list).removeClass('float-tag-selected');
      this._options.selectedIndex = list.length - 1;
      $(list[this._options.selectedIndex]).addClass('float-tag-selected');
      setTimeout(function () {
        _this._children['flat-window-scrollbar'].scrollToBottom();
        _this.scrollLocked = true;
      }, 0);
    } else {
      $(list).removeClass('float-tag-selected');
      this._options.selectedIndex = index;
      $(list[this._options.selectedIndex]).addClass('float-tag-selected');
      setTimeout(function () {
        _this.scrollToTarget(index);
      }, 0);
    }
  }
};

FloadWindow.prototype.scrollToTarget = function (key) {
  var scroll;
  var list = this.getElement().find('.im-float-content').children();
  if (key > list.length - 1) return;
  var tagTop = $(list[key]).position().top;
  var wrapHeight = this.getElement().height();

  if (tagTop >=
    0 && tagTop <= wrapHeight - $(list[key]).outerHeight()
  ) {
    scroll = false;
  }
  else if (tagTop < 0) {
    scroll = tagTop;
  } else {
    scroll = $(list[key]).outerHeight() - (wrapHeight - tagTop);
  }
  if (scroll) {
    this._children['flat-window-scrollbar'].scroll(scroll);
  }
};

FloadWindow.prototype.outputMessage = function (value) {
  this.triggerEvent('outputMessage', value);
};
FloadWindow.prototype.move = function (left, top) {
  if (!window.getSelection) return;
  var x, y;
  var rect;
  var sel = window.getSelection();
  if (sel.rangeCount) {
    var range = sel.getRangeAt(0).cloneRange();
    if (range.getClientRects) {
      range.collapse(true);
      var rects = range.getClientRects();
      if (rects.length > 0) {
        rect = rects[0];
      }
      // 光标在行首时，rect为undefined
      if (rect) {
        x = rect.left;
        y = rect.top;
      }
    }
  }
  var positions = {};
  if (!isNaN(x - this._options.width / 2)) {
    positions.left = x - this._options.width / 2 + 51;
  }
  this.triggerEvent('floatWindowMove', positions);
};
FloadWindow.prototype.hide = function () {
  this._element.hide();
};
FloadWindow.prototype.reset = function () {
  var _this = this;
  var list = _this.getElement().find('.im-float-content').children();
  $(list).removeClass('float-tag-selected');
  _this._options.selectedIndex = 0;
  _this.fullfilled = false;
  $(list[0]).addClass('float-tag-selected');
  _this.move();
  setTimeout(function () {
    _this._children['flat-window-scrollbar'].scrollToTop();
  }, 0);
};

module.exports = FloadWindow;
